export const GET_SCREEN_DATA = 'GET_SCREEN_DATA'
export const GET_SCREENS_DATA = 'GET_SCREENS_DATA'
export const CREATE_SCREEN = 'CREATE_SCREEN'
export const UPDATE_SCREEN = 'UPDATE_SCREEN'
export const SET_SCREENS_DATA = 'SET_SCREENS_DATA'
export const SET_SCREENS_PROCESSING = 'SET_SCREENS_PROCESSING'
export const SET_SCREENS_ERROR = 'SET_SCREENS_ERROR'
export const SET_SCREEN_DATA = 'SET_SCREEN_DATA'

export function getScreen (payload) {
  return {
    type: GET_SCREEN_DATA,
    payload,
  }
}

export function setScreen (payload) {
  return {
    type: SET_SCREEN_DATA,
    payload,
  }
}

export function getScreensData (payload) {
  return {
    type: GET_SCREENS_DATA,
    payload,
  }
}

export function setScreensData (payload) {
  return {
    type: SET_SCREENS_DATA,
    payload,
  }
}

export function createScreen (payload) {
  return {
    type: CREATE_SCREEN,
    payload,
  }
}

export function updateScreen (payload) {
  return {
    type: UPDATE_SCREEN,
    payload,
  }
}

export function setScreensProcessing (payload) {
  return {
    type: SET_SCREENS_PROCESSING,
    payload,
  }
}

export function setScreensError (payload) {
  return {
    type: SET_SCREENS_ERROR,
    payload,
  }
}
